import '../layout/theme';
import docReady from '../receipts/docReady';
import { drawDefaultLayout } from './components/layout/DefaultLayout';

docReady(() => {
  drawDefaultLayout();
});
